<template lang="pug">
  header.app-header.text-black.lg-text-white.pointer-events-none.lg-hover-pointer-events-auto(:class="{'app-header--cart': cart}")
    //- top bar
    .absolute.z-10.w-full.leading-none.text-13.uppercase
      .flex.w-full.items-center.justify-between
        //- left
        .h-40.flex.items-center.pointer-events-auto
          //- (mobile: menu btn)
          button.block.lg-hidden.ml-4.p-8.md-ml-8(aria-label="Menu", @click="mblMenu = !mblMenu")
            span.block.border-t.border-b.border-current(style="height:.9rem;width:3.9rem;")
          //- menu
          nav.hidden.lg-block.px-16(v-if="site")
            wp-link(v-for="item in site.menu_left", :link="item.link", linkClss="app-header__link px-1 inline-block mr-20")  {{ item.link.title }}
        //- right
        .h-40.flex.items-center.pointer-events-auto
          nav.pointer-events-auto
            //- stockists
            template(v-if="site")
              wp-link.hidden.lg-inline-block(v-for="item in site.menu_right", :link="item.link", linkClss="app-header__link px-1 inline-block ml-20")  {{ item.link.title }}
            //- cart button
            button.inline-block.uppercase.p-16(@click.stop="cartCount && showCart()", :class="{'cursor-default': !cartCount}")
              .text-9.sm-text-inhrt.inline-block.px-1.lg-ml-64.lg-mr-5(:class="{'app-header__link': !cartCount, 'router-link-active': cartCount}") Cart
              .inline-block.text-right.lg-text-white.ml-10 {{cartCount}}
    //- mobile menu (dropdown)
    nav.absolute.lg-hidden.h-screen.w-full.top-0.left-0.uppercase.leading-none.text-20.text-black(:class="{'pointer-events-auto': mblMenu}", @click="mblMenu = false")
      .min-h-72.lg-min-h-0.backdrop-blur.absolute.w-full.bg-white-60
        transition(name="none")
          ul.list-reset.pt-60.px-16.pb-32(v-show="mblMenu", v-if="site")
            li.mb-6.my-8(v-for="itm in site.menu_mobile")
              wp-link(:link="itm.link") {{ itm.link.title }}
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import Logo from '@/components/Logo'
import wpLink from '@/components/WPLink'
export default {
  name: 'AppHeader',
  props: ['hasLanding'],
  data () {
    return {
      mblMenu: false,
      hasScrolled: false
    }
  },
  computed: {
    ...mapState(['site', 'cart']),
    ...mapGetters(['cartCount'])
  },
  methods: {
    ...mapMutations(['showCart', 'hideCart'])
  },
  components: { Logo, wpLink }
}
</script>

<style>
@import '../style/_variables.css';
@media (hover:hover) and (--bkpt-lg) {
  .app-header{
    mix-blend-mode: exclusion;
    & .app-header__link {
      transition: background-color 0s 50ms;
    }
    &:not(:hover) .app-header__link:not(.router-link-active){
      color: var(--gray-900);
      background:var(--white);
    }
    & .router-link-active{
      color:var(--white);
    }
    &:hover{
      color: var(--yellow);
    }
    &:hover a.router-link-active{
      text-decoration: underline;
      color:inherit;
    }
  }
  .app-header:hover,
  .app-header.app-header--cart{
    & .app-header__link{
      background: none;
      transition: background-color 0s;
    }
  }
}
</style>
